import { Component, Input} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-search-cnpj',
  templateUrl: './input-search-cnpj.component.html',
  styleUrls: ['./input-search-cnpj.component.scss']
})
export class InputSearchCNPJComponent {

  @Input() title:string;
  @Input() name:string;
  @Input() formGroup:FormGroup;
  @Input() controlName:string;

  constructor() { }

  get formControl(): AbstractControl{
    return this.formGroup.controls[this.controlName];
  }

}
